import setMenuItem from 'Helpers/setMenuItem'
import { notifyParent } from 'mailup-react-helpers'
import { PageHeader } from 'mailup-web-components'
import React, { type FC, useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'

const Header: FC = () => {
  const intl = useIntl()
 const navigate = useNavigate()
  useEffect(() => {
    setMenuItem('RecipientsImportChooseType')
  })

  const breadcrumbsItems = [
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Recipients' }),
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Import' }),
    },
    {
      label: intl.formatMessage({ id: 'Load.MailupCommon.New' }),
    },
  ]

  const menuItems = [
    {
      label: intl.formatMessage({ id: 'Load.MailupCommon.New' }),
      isActive: true,
    },
    {
      label: intl.formatMessage({ id: 'Load.MailupCommon.Status' }),
      onClick: () =>
        navigate(`/recipients/import/status`)
    },
  ]

  return (
    <PageHeader
      breadcrumbsItems={breadcrumbsItems}
      menuItems={menuItems}
      title={intl.formatMessage({ id: 'Load.MailupCommon.New' })}
    />
  )
}

export default Header
